




























import { Component, Prop, Vue } from "vue-property-decorator";

let id = 0;

@Component
export default class CollapsePanel extends Vue {
    @Prop() private value!: boolean;

    id: string = "";

    created() {
        this.id = "CollapsePanel" + id;
        id++;
    }

    collapse() {
        this.$emit("input", false);
    }

    expand() {
        this.$emit("input", true);
    }
}
